import React from "react";

const AppLoader: React.FC = () => {
  return (
    <div className="center-align-container">
      <div className="spinner"></div>
    </div>
  );
};

export default AppLoader;
